<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.edit_area_data") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Name Input -->
          <base-image-upload-input
            col="12"
            identifier="image"
            :placeholder="$t('PLACEHOLDERS.advantage_image')"
            @selectImage="selectImage"
            :acceptVideo="true"
            :preSelectedImage="data.image.path"
            required
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.advantage_name_ar')"
            v-model.trim="data.name_ar"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.advantage_name_en')"
            v-model.trim="data.name_en"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.advantage_description_ar')"
            v-model.trim="data.description_ar"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.advantage_description_en')"
            v-model.trim="data.description_en"
            required
          />
          <!-- End:: Country Input -->

          <!-- Start:: Deactivate Switch Input -->
          <!-- <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div> -->
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "CreateCity",

  
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",

      // Start:: Data Collection To Send
      data: {
        name_ar: null,
        name_en: null,
        description_ar: null,
        description_en: null,
        image: {
          path: null,
          file: null,
        

},
        active: true,
      },
      // End:: Data Collection To Send
      areas: [],
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,

      coordinates: [],
      areaPoints: [],
      countries: [],
    };
  },

  methods: {
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      if (!this.data.name_ar || !this.data.name_en) {
        if (!this.data.name_ar) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.name_ar"));
          return;
        }
        if (!this.data.name_en) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.name_en"));
          return;
        }
      } else {
        this.submitForm();
      }
    },
    // End:: validate Form Inputs

    handleSaveArea(coordinates) {
      // Handle the saved area coordinates from the child component

      this.coordinates = coordinates;
    },

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      console.log(this.data);
      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }
      console.log(this.data.description_ar);
      if (this.data.description_ar) {
        REQUEST_DATA.append("description[ar]", this.data.description_ar);
      }
      if (this.data.description_en) {
        REQUEST_DATA.append("description[en]", this.data.description_en);
      }
      if (this.data.image?.file) {
        REQUEST_DATA.append("image", this.data.image?.file);
      }
      REQUEST_DATA.append("_method", "PUT");
      console.log(this.data.active);
      // Start:: Append Request Data
      try {
        await this.$axios({
          method: "POST",
          url: `advantages/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/advantages/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      
        this.loading = false;}
    },
    // End:: Submit Form

    // start show data
    async showData() {
      try {
        this.loading = true;
        let res = await this.$axios({
          method: "GET",
          url: `advantages/${this.$route.params?.id}`,
        });
        this.data.name_ar = res.data.data.Advantage.name_ar;
        this.data.name_en = res.data.data.Advantage.name_en;
        this.data.description_ar = res.data.data.Advantage.description_ar;
        this.data.description_en = res.data.data.Advantage.description_en;
        this.data.image.path = res.data.data.Advantage.image;
        this.data.active = res.data.data.Area.is_active;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      
        this.loading = false;}
    },
    // end show data
    async getCountries() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `countries?page=0&limit=0&is_active=1`,
        });
        this.countries = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      
        this.loading = false;}
    },
  },

  created() {
    // Start:: Fire Methods
    this.getCountries();
    this.showData();
    // End:: Fire Methods
  },
};
</script>
